export namespace Icon {
  export const Names: {
    Petronas: 'Petronas';
    HistoricalMr: 'HistoricalMr';
    Clipboard: 'Clipboard';
    UserManagement: 'UserManagement';
    Settings: 'Settings';
  } = {
    Petronas: 'Petronas',
    HistoricalMr: 'HistoricalMr',
    Clipboard: 'Clipboard',
    UserManagement: 'UserManagement',
    Settings: 'Settings',
  };

  export type Names = (typeof Names)[keyof typeof Names];
}
